import reqwest from 'reqwest';
import { apiUrl } from './config';
import session from './session';

export default {
  /**
   * 背调报告概览
   * @param {string} reportId 报告ID
   */
  reportOverview(reportId) {
    return reqwest({
      url: `${apiUrl}/business-api/api/bgcheck/report/overview`,
      method: 'get',
      data: { reportId },
      headers: {
        sessionId: session.get(),
      },
    });
  },
  /**
   * 背调报告详情
   * @param {string} reportId 报告ID
   */
  reportDetail(reportId) {
    return reqwest({
      url: `${apiUrl}/business-api/api/bgcheck/report/detail`,
      method: 'get',
      data: { reportId },
      headers: {
        sessionId: session.get(),
      },
    });
  },
};
